import React from 'react';
import { connect } from 'react-redux';

import styles from './SuggestionModal.module.less';

const SuggestionModal = ({
  variant,
  attireSuggestions,
  questionSuggestions,
  addSuggestion,
  hideModalFn,
  toggleSuggestions,
}) => {
  const suggestions =
    variant === 'attire' || variant === 'websiteAttire' ? attireSuggestions : questionSuggestions;
  const suggestionType = variant === 'websiteAttire' ? 'attire' : variant;
  const title =
    suggestionType === 'attire'
      ? 'Most Common Attires Suggested By Zola Couples'
      : 'Most Common Questions Asked By Zola Couples';

  const setSuggestion = (e, text) => {
    addSuggestion(text);
    if (hideModalFn) {
      hideModalFn();
    } else if (toggleSuggestions) {
      toggleSuggestions();
    }
  };

  return variant === 'websiteAttire' ? (
    <ul className={`suggestion-list list-unstyled -${variant}`}>
      {suggestions &&
        suggestions.map((suggestion, idx) => (
          <li className={`suggestion common-${variant} ${styles.suggestionItem}`} key={idx}>
            <button
              className={styles.suggestionBtn}
              onClick={e => setSuggestion(e, suggestion[suggestionType])}
            >
              <span className="suggestion__text">{suggestion[suggestionType]}</span>
              <span className={`${styles.suggestionSelect} text-button`}>Select &rsaquo;</span>
            </button>
          </li>
        ))}
    </ul>
  ) : (
    <div className="rsvp-suggestions">
      <div className={styles.modalHeader}>
        <h3 className={styles.modalTitle}>{title}</h3>
      </div>
      <div className={styles.modalBody}>
        <ul className={`suggestion-list list-unstyled -${suggestionType}`}>
          {suggestions &&
            suggestions.map((suggestion, idx) => (
              <li
                className={`suggestion common-${suggestionType} ${styles.suggestionItem}`}
                key={idx}
              >
                <button
                  className={styles.suggestionBtn}
                  onClick={e => setSuggestion(e, suggestion[suggestionType])}
                >
                  <span className="suggestion__text">{suggestion[suggestionType]}</span>
                  <span className={`${styles.suggestionSelect} text-button`}>Select &rsaquo;</span>
                </button>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  attireSuggestions: state.events.events.suggestedAttireOptions,
  questionSuggestions: state.events.rsvp.suggestions,
});

export default connect(mapStateToProps)(SuggestionModal);



// WEBPACK FOOTER //
// ./src/pages/Events/SuggestionModal/SuggestionModal.jsx